import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    positions: [],
    playing: false,
    datePointer: new Date(),
    focusAStart: new Date('2020-05-05T09:00:00.000Z'),
    focusAEnd: new Date('2020-05-05T09:21:40.000Z'),
    loaded: false,
    exhibitions: [],
    selectedExhibition: null,
    exhibitionsLoaded: false,
    rooms: [],
    selectedRoom: null,
    bottomSVG: null,
    overlaySVG: null,
    heatmap: null,
    heatmapEnabled: false,
  },
  mutations: {
    loadPositions(state, positions) {
      state.positions = positions;
    },
    switchPlayback(state) {
      state.playing = !state.playing;
    },
    moveDatePointer(state, delta) {
      state.datePointer = new Date(
        state.datePointer.setSeconds(
          state.datePointer.getSeconds() + delta,
        ),
      );
    },
  },
  actions: {
  },
  modules: {
  },
});
